import { Injectable } from '@angular/core';
import { ProjectSetup, UserSession } from '@shared/models';
import { DprDetails } from '@shared/models/dpr';
import { UserDetailsFacade } from '@shared/state/facades';
import { OfflineFacade } from '@shared/state/facades/offline.facade';
import { Observable } from 'rxjs';
import { BasePersistenceService } from '.';

@Injectable()
export class LocalPersistenceService extends BasePersistenceService {
  constructor(
    private userDetailsFacade: UserDetailsFacade,
    private offlineFacade: OfflineFacade
  ) {
    super();
  }

  // user session

  getUserSession(): Observable<UserSession> {
    return this.userDetailsFacade.query.userDetails$;
  }

  getProjectSetup(): Observable<ProjectSetup> {
    return this.userDetailsFacade.query.projectSetup$;
  }

  getLastThreeDprs(): Observable<DprDetails[]> {
    return this.offlineFacade.query.dprDetailsList$;
  }
}
